import { SectionType } from "@tm/types";
import { componentMapper } from "../componentMapper";

export const RenderSection = ({ component, className }: any) => {
  const { type, data }: { type: SectionType; data: any } = component;
  const Component = componentMapper[type];
  return Component ? <Component {...data} className={className} /> : null;
};
